import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import PercentIcon from "@mui/icons-material/Percent";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import CustomModal from "src/components/customerinput/CustomModal";
import CustomInput from "src/components/customerinput/CustomerInput";
import { useAuthContext } from "src/auth/useAuthContext";
import { handleKeyPress } from "src/functions";
import { eventDiscount } from "src/schemas";
import { notify } from "src/components/notify";
import { CoinIcon } from "src/svgs";
import createEventDiscount from "src/services/events/createDiscount";
export default function CreateDiscountModal({
  close,
  open,
  eventData,
  setDiscountData,
}) {
  const { user, logout } = useAuthContext();
  const [isloading, setIsloading] = useState(false);
  const [code, setCode] = useState("");
  const {
    handleChange,
    handleSubmit,
    values,
    handleBlur,
    setFieldValue,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      coupon_name: "",
      valid_from: dayjs().add(30, "second"),
      valid_till: dayjs(eventData?.distribution_end),
      usage_limit: "",
      percentage: "",
      event: "",
      is_discount_visible: "true",
      code: "true",
      is_points: "false",
      multi_limit: "false",
      multi_use: "",
      description: "",
      min_limit: "false",
      max_limit: "false",
      min_amount: "",
      max_amount: "",
    },
    validationSchema: eventDiscount,
    onSubmit: async (value) => {
      try {
        if (!value.valid_from || !value?.valid_till) {
          notify("Date is required.");
          return;
        }
        if (values?.min_limit == "true") {
          if (!values?.min_amount?.trim()) {
            notify("Min Ticket Amount is required.");
            return;
          }
        }
        if (values?.max_limit == "true") {
          if (!values?.max_amount?.trim()) {
            notify("Max Discount Amount is required.");
            return;
          }
        }

        if (values?.multi_use === "" && values?.multi_limit == "true") {
          notify("Enter Discount Usage Limit Per Customer");
          return;
        }

        // if (
        //   values?.multi_limit === "true" &&
        //   values?.multi_use < values?.usage_limit
        // ) {
        //   notify("Multi-use limit   less than usage limit.");
        //   return;
        // }

        setIsloading(true);
        let newValues = {
          ...value,
          is_discount_visible:
            value.is_discount_visible == "false" ? false : true,
          is_points: value.is_points == "false" ? false : true,
          multi_use:
            value.multi_limit === "false" ? 1 : Number(value.multi_use),
          usage_limit: value.usage_limit
            ? Number(value.usage_limit)
            : value.usage_limit,
          valid_from: dayjs(value?.valid_from).format(),
          valid_till: dayjs(value?.valid_till).format(),
        };
        let isCode = value.code == "true" ? false : true;
        if (value?.is_points == "true") {
          newValues.max_amount = "";
        }
        if (isCode) {
          if (code.length < 12) {
            notify("Discount code should be 12 character.");
            return;
          }
          newValues = {
            ...newValues,
            handle: code,
          };
        }
        if (value?.min_limit != "true") {
          delete newValues.min_amount;
        }
        if (value?.max_limit != "true") {
          delete newValues.max_amount;
        }
        delete newValues.code;
        delete newValues?.min_limit;
        delete newValues?.max_limit;
        const { data } = await createEventDiscount(user, newValues, logout);

        if (data) {
          setDiscountData((prev) => {
            return [...prev, { ...data, tickets: [] }];
          });
          notify("Discount coupon created.", "success");
          close();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsloading(false);
      }
    },
  });

  useEffect(() => {
    setFieldValue("event", eventData?._id);
  }, [open]);

  console.log(values?.multi_use, "values?.multi_use");

  return (
    <CustomModal
      heading="Create Ticket Discount"
      open={open}
      close={close}
      action={
        <LoadingButton
          variant="contained"
          form="discount"
          loading={isloading}
          disabled={isloading}
          type="form"
        >
          Generate
        </LoadingButton>
      }
    >
      <form id="discount" onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CustomInput
              label="Discount Name"
              required
              input={
                <TextField
                  fullWidth
                  name="coupon_name"
                  value={values?.coupon_name || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Discount Name"
                  helperText={
                    errors?.coupon_name && touched.coupon_name
                      ? errors?.coupon_name
                      : null
                  }
                  inputProps={{ maxLength: 25 }}
                  error={
                    errors?.coupon_name && touched.coupon_name ? true : false
                  }
                />
              }
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              label="Discount Description (Optional)"
              input={
                <TextField
                  fullWidth
                  name="description"
                  value={values?.description || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Discount Description"
                  helperText={
                    errors?.description && touched.description
                      ? errors?.description
                      : null
                  }
                  error={
                    errors?.description && touched.description ? true : false
                  }
                />
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">Discount Code</Typography>
              <FormControl>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  value={values?.code}
                  name="code"
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Auto Generated"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="Manual"
                  />
                </RadioGroup>
              </FormControl>
              {values?.code == "false" && (
                <CustomInput
                  label="Create a code"
                  required
                  input={
                    <TextField
                      fullWidth
                      placeholder="add a 12 character code "
                      onChange={(e) => {
                        const uppercaseNoSpacesValue = e.target.value
                          .toUpperCase()
                          .replace(/[^A-Z0-9]/g, "");
                        setCode(uppercaseNoSpacesValue.trim());
                      }}
                      sx={{
                        input: {
                          textTransform: "uppercase",
                        },
                      }}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      inputProps={{ maxLength: 12 }}
                      values={code}
                    />
                  }
                />
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <CustomInput
                    required
                    label="Discount Value"
                    helperText={
                      errors?.percentage && touched.percentage
                        ? errors?.percentage
                        : null
                    }
                    helperColor="red"
                    input={
                      <OutlinedInput
                        fullWidth
                        helperText={
                          errors?.percentage && touched.percentage
                            ? errors?.percentage
                            : null
                        }
                        error={
                          errors?.percentage && touched.percentage
                            ? true
                            : false
                        }
                        inputProps={{
                          maxLength: values?.is_points == "false" ? 3 : 6,
                        }}
                        name="percentage"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyPress}
                        placeholder="Max Bookings Can be taken"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              {values?.is_points == "false" ? (
                                <PercentIcon color="primary" />
                              ) : (
                                <CoinIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <CustomInput
                    label={<p style={{ visibility: "hidden" }}>.</p>}
                    input={
                      <TextField
                        fullWidth
                        name="is_points"
                        value={values?.is_points}
                        onChange={handleChange}
                        select
                      >
                        <MenuItem value="false">Percentage</MenuItem>
                        <MenuItem value="true">Fixed</MenuItem>
                      </TextField>
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">Minimum Ticket Value</Typography>
              <FormControl>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  value={values?.min_limit}
                  name="min_limit"
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No Min Limit"
                  />
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Add Min Amount"
                  />
                </RadioGroup>
              </FormControl>
              {values?.min_limit == "true" && (
                <CustomInput
                  label="Add Min Ticket Amount"
                  required
                  input={
                    <TextField
                      fullWidth
                      placeholder="Add Amount"
                      onChange={handleChange}
                      name="min_amount"
                      onKeyDown={handleKeyPress}
                      values={values?.min_amount}
                      inputProps={{ maxLength: 6 }}
                    />
                  }
                />
              )}
            </Box>
          </Grid>
          {values?.is_points == "false" && (
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px solid lightGrey",
                  borderRadius: "8px",
                  padding: "10px",
                  marginTop: "8px",
                }}
              >
                <Typography variant="subtitle2">
                  Maximum Discount Amount
                </Typography>
                <FormControl>
                  <RadioGroup
                    sx={{ display: "flex", flexDirection: "row" }}
                    value={values?.max_limit}
                    name="max_limit"
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label="No Max Limit"
                    />
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label="Add Max Discount Amount"
                    />
                  </RadioGroup>
                </FormControl>
                {values?.max_limit == "true" && (
                  <CustomInput
                    label="Add Max Discount Amount"
                    required
                    input={
                      <TextField
                        fullWidth
                        placeholder="Add Amount"
                        onChange={handleChange}
                        name="max_amount"
                        onKeyDown={handleKeyPress}
                        values={values?.max_amount}
                        inputProps={{ maxLength: 6 }}
                      />
                    }
                  />
                )}
              </Box>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">
                Discount Usage Limit Per Customer
              </Typography>
              <FormControl>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  value={values?.multi_limit}
                  name="multi_limit"
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="Once Per User"
                  />
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Add Limit Per User"
                  />
                </RadioGroup>
              </FormControl>
              {values?.multi_limit == "true" && (
                <CustomInput
                  label="Add usage limit per user"
                  required
                  input={
                    <TextField
                      fullWidth
                      placeholder="add usage limit"
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "" || parseInt(value, 10) >= 1) {
                          handleChange(e);
                        }
                      }}
                      name="multi_use"
                      onKeyDown={handleKeyPress}
                      value={values?.multi_use}
                      inputProps={{ maxLength: 6 }}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                    />
                  }
                />
              )}
            </Box>
          </Grid>
          {/* {console.log(values?.multi_use,"values?.multi_use")} */}

          {/* Discount Visibility */}
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">Discount Visibility</Typography>
              <FormControl>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  value={values?.is_discount_visible}
                  name="is_discount_visible"
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Visible on event page"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="Only to shared users"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              required
              label="Discount Usage Limit"
              input={
                <TextField
                  name="usage_limit"
                  onKeyDown={handleKeyPress}
                  value={values?.usage_limit}
                  helperText={
                    errors?.usage_limit && touched.usage_limit
                      ? errors?.usage_limit
                      : null
                  }
                  error={
                    errors?.usage_limit && touched.usage_limit ? true : false
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  placeholder="Discount Usage Limit"
                />
              }
            />
          </Grid>
          <Grid item xs={6}>
            <CustomInput
              required
              label="Validity"
              input={
                <DateTimePicker
                  name="valid_from"
                  disablePast
                  minDate={dayjs(eventData?.distribution_start)}
                  maxDate={dayjs(eventData?.distribution_end)}
                  value={values?.valid_from || null}
                  minutesStep={1}
                  timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                  onChange={(e) => setFieldValue("valid_from", e)}
                  sx={{ width: "100%" }}
                />
              }
            />
          </Grid>
          <Grid item xs={6}>
            <CustomInput
              label={<p style={{ visibility: "hidden" }}>.</p>}
              input={
                <DateTimePicker
                  name="valid_till"
                  maxTime={
                    eventData?.slots ? null : dayjs(eventData?.distribution_end)
                  }
                  timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                  disablePast
                  value={values?.valid_till}
                  minDate={
                    values?.valid_from ? dayjs(values?.valid_from) : null
                  }
                  maxDate={
                    eventData?.slots ? null : dayjs(eventData?.distribution_end)
                  }
                  onChange={(e) => setFieldValue("valid_till", e)}
                  sx={{ width: "100%" }}
                />
              }
            />
          </Grid>
        </Grid>
      </form>
    </CustomModal>
  );
}
